import { NavigationError } from '@angular/router';

/**
 * Recovers an already-open session after a frontend deploy.
 *
 * Lazy routes are served as content-hashed chunks (outputHashing: 'all'). When a
 * new frontend version is deployed, a tab still running the previous index.html
 * references chunk filenames that no longer exist on the server. Navigating to a
 * not-yet-loaded lazy route then fails with a ChunkLoadError. A full page reload
 * fetches the new index.html + chunk manifest and the navigation succeeds.
 *
 * The 10s guard prevents a reload loop when the failure is genuinely persistent
 * (offline, a real server error) rather than a stale-deploy chunk miss.
 */
export function reloadOnStaleChunk(e: NavigationError): void {
  const error = e.error as { name?: string; message?: string } | undefined;
  const message = String(error?.message ?? error ?? '');
  const isChunkError =
    error?.name === 'ChunkLoadError' ||
    /Loading chunk|dynamically imported module|Failed to fetch/i.test(message);

  if (!isChunkError) {
    return;
  }

  const KEY = 'chunkReloadAt';
  const last = Number(sessionStorage.getItem(KEY) ?? 0);
  if (Date.now() - last > 10_000) {
    sessionStorage.setItem(KEY, String(Date.now()));
    location.reload();
  }
}
